import { useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { api, errMsg } from "../lib/api";

export const JoinTournamentDialog = ({ open, onOpenChange }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/tournaments/join", { code: code.trim().toUpperCase() });
      toast.success("Sei entrato nel torneo!");
      onOpenChange(false);
      const id = r.data.id || r.data.tournament?.id;
      nav(id ? `/tournament/${id}` : "/");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121824] border-[#26334D] max-w-md" data-testid="join-tournament-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-black uppercase">Unisciti a un torneo</DialogTitle>
          <DialogDescription>Inserisci il codice invito ricevuto da un amico.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5">
          <Input
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={10}
            required
            placeholder="ABC123"
            data-testid="join-code-input"
            className="h-14 text-center font-mono text-2xl tracking-[0.4em] bg-[#0A0D14] border-[#26334D]"
          />
          <Button type="submit" disabled={busy} data-testid="join-tournament-submit" className="w-full h-11 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0A0D14] font-bold uppercase tracking-wider">
            {busy ? "Attendere…" : "Entra"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
